module.exports = __webpack_public_path__ + "static/media/arrow-link.2fa61b8b.svg";